<template>
  <div class="class-list">
    <GlobalInfoBar
      title="问答配置"
      content="配置门店端小程序或H5页面问答展示信息"
    />
    <!-- <Info/> -->
    <GlobalChunkNo icon="search" title="筛选查询">
      <div slot="filter">
        <From :option="typeOptions"/>
      </div>
      <Table  :option="typeOptions"/>
    </GlobalChunkNo>
  </div>
</template>

<script>
import From from "./Form";
import Table from "./Table";
import _api from "@/utils/request";
export default {
  name: "class-list",
  components: {
    From,
    Table,
  },
  data() {
    return {
      typeOptions: []
    };
  },
  created() {
    this.getTypeSelect();
  },
  methods: {
    // 获取问题类型
    getTypeSelect() {
      _api.templateTypeSelect().then((res) => {
        this.typeOptions = res.data;
        console.log(this.option);
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.class-list {
}
</style>